import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, NavLink} from "react-router-dom";
import Instafeed from 'react-instafeed';

class OpenPositions extends Component {
  constructor (props) {
    super(props)
  }

  render() {
    const instafeedTarget = 'instafeed';

    // temp fix - empty container before filling.
    if(document.getElementById(instafeedTarget)) {
      document.getElementById(instafeedTarget).innerHTML = "";
    }

    return (
      <div className="instawrapper">
        <div className="content-wrapper instafeed">
          <div id={instafeedTarget}>
            <Instafeed
              limit='15'
              ref='instafeed'
              resolution='standard_resolution'
              sortBy='most-recent'
              target={instafeedTarget}
              template='<div class="insta-wrap">
              <div class="instagram-img" style="background-image:url({{image}})"></div>
              </div>'
              userId='6761754058'
              clientId='65b133dee7e445b1b707d26f17fbba95'
              accessToken='6761754058.1677ed0.050f85dbdeb644ad9884bc15be7ef484'
            />
          </div>
          <div className="content">
            <div className="section-subheading">Join the team</div>
            <div className="section-heading">join the universe</div>
            <NavLink to="/page/career" className="button-link">See open positions</NavLink>
          </div>
        </div>
      </div>
    );
  }
}

export default OpenPositions;



// WEBPACK FOOTER //
// ./client/components/comp-positions.jsx